import { Component, OnInit } from '@angular/core';
import { ApiService } from '../../api.service';
import * as moment from 'moment';

enum calendarViewTypes {
    YEAR = 'year',
    MONTH = 'month'
}

@Component({
  selector: 'app-calendar-birthday',
  templateUrl: './calendar-birthday.component.html',
  styleUrls: ['./calendar-birthday.component.css']
})
export class CalendarBirthdayComponent implements OnInit {
    birthdays: any;
    months: any;
    year: number; // year to display if calendar type: year is selected
    month: number; // month to display if calendar type: month is selected
    viewtype: calendarViewTypes;
    calendarViewTypes;
    // todo: allow to display a week view too
    constructor(protected apiService: ApiService) {
        this.viewtype = calendarViewTypes.YEAR;
        this.calendarViewTypes = calendarViewTypes;
        this.year = moment().year();
        this.month = moment().month();
        this.apiService.getAll('birthdays').subscribe((val) => {
            this.birthdays = val;
            this.getMonths();
        });
    }

    public nextYear() {
        this.year++;
        this.getMonths();
    }

    public prevYear() {
        this.year--;
        this.getMonths();
    }

    public nextMonth() {
        this.month++;
        if (this.month > 11) {
            this.month = 0;
            this.year++;
            this.getMonths();
        }
    }

    public prevMonth() {
        this.month--;
        if (this.month < -1) {
            this.month = 11;
            this.year--;
            this.getMonths();
        }
    }

    public setViewType(viewType: calendarViewTypes) {
        this.viewtype = viewType;
    }


    protected getMonths() {
        this.months = new Array();
        for (let a = 0; a < 12; a++) {
            this.months.push(this.getMonth(a));
        }
    }

    public getMonth(month) {
        const firstDayOfMonth = moment().year(this.year).month(month).date(0).day();
        const monthName = moment().year(this.year).month(month).format('MMMM');
        const daysOfLastMonth = new Array();
        const weeks = new Array();
        let calendarDay = 0 - firstDayOfMonth;
        let daysMonth;
        let nextDaysMonth = month;
        do {
            const week = new Array();
            for (let i = 1; i < 8; i++) {
                calendarDay++;
                daysMonth = moment().year(this.year).month(month).date(calendarDay).month();
                const day = moment().year(this.year).month(month).date(calendarDay).date();
                let monthType = 0; // is it a day from the previous month, current month or next month
                const monthBirthdays = this.birthdays.filter((val) => {
                    const bday = new Date(val.birthday);
                    const bdayDay = bday.getDate();
                    const bdayMonth = bday.getMonth();
                    return bday.getDate() === day && bday.getMonth() === daysMonth;
                });

                if (daysMonth > month && calendarDay > 1) {
                    monthType = 1;
                } else if (
                    (daysMonth > month && calendarDay < 0)
                    ||
                    (daysMonth < month)
                ) {
                    monthType = -1;
                }
                const hasBirthday = monthBirthdays.length > 0 && monthType === 0;
                const birthdaysOnThisDay = monthBirthdays.map((val) => {
                    const bday = new Date(val.birthday);
                    const age = this.year - bday.getFullYear();
                    return val.firstname + ' ' + val.lastname + ' (' + String(age) + ')';
                }); // .join('\r\n');
                const isToday =
                    day === moment().date()
                    && daysMonth === moment().month()
                    && this.year === moment().year();
                week.push({day: day, month: monthType, isToday: isToday, hasBirthday: hasBirthday, birthdaysOnThisDay: birthdaysOnThisDay});
            }
            nextDaysMonth = moment().year(this.year).month(month).date(calendarDay + 1).month();
            weeks.push(week);
        } while (month === nextDaysMonth);
        return {monthName: monthName, weeks: weeks};
    }

    ngOnInit() {
    }

}



// WEBPACK FOOTER //
// ./src/app/birthdays/calendar-birthday/calendar-birthday.component.ts